import { INDICADOR_TIPO } from '@investirapri/financa.js/lib/enums';

export const INDICADOR_DISPLAY_MODE = {
  correcao_monetaria: 'correcao_monetaria',
  juros: 'juros',
  indice_mercado: 'indice_mercado',
  moeda: 'moeda',
  metal: 'metal',
  outros: 'outros'
};

const wDisplayModeByTipo = {
  [INDICADOR_TIPO.C.id]: INDICADOR_DISPLAY_MODE.correcao_monetaria,
  [INDICADOR_TIPO.J.id]: INDICADOR_DISPLAY_MODE.juros,
  [INDICADOR_TIPO.I.id]: INDICADOR_DISPLAY_MODE.indice_mercado,
  [INDICADOR_TIPO.M.id]: INDICADOR_DISPLAY_MODE.moeda,
  [INDICADOR_TIPO.T.id]: INDICADOR_DISPLAY_MODE.metal
};

const wDisplayConfigByMode = {
  [INDICADOR_DISPLAY_MODE.correcao_monetaria]: {
    title: 'Variação',
    valueLabel: 'Variação',
    valueKey: 'taxa',
    fallbackValueKey: 'cotacao',
    suffix: '%',
    decimals: 2,
    variationLabel: 'Diferença',
    variationMode: 'points',
    variationSuffix: ' p.p.'
  },
  [INDICADOR_DISPLAY_MODE.juros]: {
    title: 'Taxa',
    valueLabel: 'Taxa',
    valueKey: 'taxa',
    fallbackValueKey: 'cotacao',
    suffix: '%',
    decimals: 2,
    variationLabel: 'Diferença',
    variationMode: 'points',
    variationSuffix: ' p.p.'
  },
  [INDICADOR_DISPLAY_MODE.indice_mercado]: {
    title: 'Pontuação',
    valueLabel: 'Pontuação',
    valueKey: 'cotacao',
    suffix: ' pts',
    decimals: 2,
    variationLabel: 'Variação',
    variationMode: 'percentage',
    variationSuffix: '%'
  },
  [INDICADOR_DISPLAY_MODE.moeda]: {
    title: 'Cotação',
    valueLabel: 'Cotação',
    valueKey: 'cotacao',
    suffix: '',
    decimals: 4,
    variationLabel: 'Variação',
    variationMode: 'percentage',
    variationSuffix: '%'
  },
  [INDICADOR_DISPLAY_MODE.metal]: {
    title: 'Cotação',
    valueLabel: 'Cotação',
    valueKey: 'cotacao',
    suffix: '',
    decimals: 2,
    variationLabel: 'Variação',
    variationMode: 'percentage',
    variationSuffix: '%'
  },
  [INDICADOR_DISPLAY_MODE.outros]: {
    title: 'Cotação',
    valueLabel: 'Cotação',
    valueKey: 'cotacao',
    suffix: '',
    decimals: 2,
    variationLabel: 'Variação',
    variationMode: 'percentage',
    variationSuffix: '%'
  }
};

/** Classifica o indicador conforme a apresentação esperada para o seu tipo canônico. */
export function getIndicadorDisplayMode(pIndicador = {}) {
  return wDisplayModeByTipo[pIndicador.indicador_tipo_id] || INDICADOR_DISPLAY_MODE.outros;
}

/** Retorna o contrato de valor, unidade e variação do modo informado. */
export function getIndicadorDisplayConfig(pDisplayMode) {
  return wDisplayConfigByMode[pDisplayMode] || wDisplayConfigByMode[INDICADOR_DISPLAY_MODE.outros];
}
